/**
 * @desc 测试沃尔玛调拨入库方法
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/test/testWalmartAllocationInBoundTimerTask`, {
      method: "GET",

      ...options,
    }),
  );
}
